import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MsalInitService } from '../../services/msal-init.service';

@Injectable({
  providedIn: 'root'
})
export class LoggedInGuard implements CanActivate {
  constructor(
    private router: Router,
    private msalService: MsalService,
    private msalInitService: MsalInitService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    return from(this.msalInitService.ensureInitialized()).pipe(
      map(() => {
        try {
          const isAuthenticated = this.msalService.instance.getAllAccounts().length > 0 &&
                                sessionStorage.getItem('Session_Id');

          if (isAuthenticated) {
            this.router.navigate(['/dashboard']);
            return false;
          }
          return true;
        } catch (error) {
          console.error('Error checking authentication in LoggedInGuard:', error);
          return true; // Allow access to login on error
        }
      }),
      catchError((error) => {
        console.error('MSAL initialization error in LoggedInGuard:', error);
        return of(true);
      })
    );
  }
}